webpackJsonp([212839066777427],{

/***/ 36:
/***/ (function(module, exports) {

	module.exports = {"name":"Mathias Schilling","contact":{"email":"m@matchilling.com","github":"https://github.com/matchilling","instagram":"https://www.instagram.com/matchilling/","lastfm":"https://www.last.fm/user/msatlastfm","linkedin":"https://www.linkedin.com/in/matchilling","reddit":"https://www.reddit.com/user/matchilling","twitter":"https://twitter.com/MatChilling"}}

/***/ }),

/***/ 43:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _profile = __webpack_require__(36);
	
	var _profile2 = _interopRequireDefault(_profile);
	
	var _profile3 = __webpack_require__(56);
	
	var _profile4 = _interopRequireDefault(_profile3);
	
	var _typography = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Biography = function (_React$Component) {
	  _inherits(Biography, _React$Component);
	
	  function Biography() {
	    _classCallCheck(this, Biography);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Biography.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { style: { display: 'flex' } },
	      _react2.default.createElement('img', {
	        alt: _profile2.default.name,
	        src: _profile4.default,
	        style: {
	          height: (0, _typography.rhythm)(3),
	          marginBottom: 0,
	          marginRight: (0, _typography.rhythm)(1 / 2),
	          width: (0, _typography.rhythm)(3)
	        }
	      }),
	      _react2.default.createElement(
	        'p',
	        null,
	        'I create',
	        ' ',
	        _react2.default.createElement(
	          'a',
	          { href: 'https://jugendstil.io/' },
	          'business impact through code'
	        ),
	        ' and help organisations become more effective in delivering solutions to their customer\'s problems. You can find me on',
	        ' ',
	        _react2.default.createElement(
	          'a',
	          { href: _profile2.default.contact.twitter, target: '_blank' },
	          'Twitter'
	        ),
	        ',',
	        ' ',
	        _react2.default.createElement(
	          'a',
	          { href: _profile2.default.contact.linkedin, target: '_blank' },
	          'LinkedIn'
	        ),
	        ',',
	        ' ',
	        _react2.default.createElement(
	          'a',
	          { href: _profile2.default.contact.github, target: '_blank' },
	          'GitHub'
	        ),
	        ',',
	        ' ',
	        _react2.default.createElement(
	          'a',
	          { href: _profile2.default.contact.reddit, target: '_blank' },
	          'Reddit'
	        ),
	        ', and',
	        ' ',
	        _react2.default.createElement(
	          'a',
	          { href: _profile2.default.contact.lastfm, target: '_blank' },
	          'Last.fm'
	        ),
	        '.'
	      )
	    );
	  };
	
	  return Biography;
	}(_react2.default.Component);
	
	exports.default = Biography;
	module.exports = exports['default'];

/***/ }),

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reactHelmet = __webpack_require__(54);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(60);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _biography = __webpack_require__(43);
	
	var _biography2 = _interopRequireDefault(_biography);
	
	var _typography = __webpack_require__(13);
	
	var _profile = __webpack_require__(56);
	
	var _profile2 = _interopRequireDefault(_profile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var standard = function standard(post) {
	  return _react2.default.createElement(
	    'a',
	    {
	      className: 'article-preview standard',
	      key: post.node.frontmatter.path,
	      href: post.node.frontmatter.path
	    },
	    _react2.default.createElement(
	      'h2',
	      {
	        style: {
	          fontSize: '1.4427rem',
	          lineHeight: '1.1',
	          marginBottom: (0, _typography.rhythm)(1 / 4),
	          marginTop: (0, _typography.rhythm)(2)
	        }
	      },
	      post.node.frontmatter.title
	    ),
	    _react2.default.createElement(
	      'small',
	      { style: { color: 'rgba(0, 0, 0, 0.35)' } },
	      post.node.frontmatter.date
	    ),
	    _react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: post.node.excerpt } })
	  );
	};
	
	var top = function top(post, imgAlignLeft) {
	  var re = /\"(\/static.*?)\"/g;
	  var firstImageUrl = post.node.html.match(re);
	  var url = firstImageUrl ? 'https://www.matchilling.com' + firstImageUrl[0].replace(/['"]+/g, '') : undefined;
	  var tags = post.node.frontmatter.tags != null ? post.node.frontmatter.tags.split(',') : [];
	  var readTime = function readTime(words, options) {
	    var defaults = _extends({
	      wordsPerMinute: 225
	    }, options),
	        minutes = words / defaults.wordsPerMinute;
	
	    return Math.ceil(minutes.toFixed(2)) + ' min read';
	  };
	
	  var img = function img(url) {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement('div', {
	        style: {
	          backgroundImage: 'url(' + url + ')',
	          height: '354px',
	          width: '354px',
	          backgroundSize: 'cover',
	          backgroundRepeat: 'no-repeat'
	        }
	      })
	    );
	  };
	
	  var preview = function preview(post) {
	    return _react2.default.createElement(
	      'div',
	      {
	        style: {
	          display: 'flex',
	          padding: '0 1rem 0 3rem',
	          border: '1px solid rgba(208, 208, 208, 0.24)'
	        }
	      },
	      _react2.default.createElement(
	        'div',
	        {
	          style: {
	            margin: 'auto 3rem'
	          }
	        },
	        _react2.default.createElement(
	          'h2',
	          {
	            style: {
	              fontSize: '1.2427rem',
	              lineHeight: '1.9rem',
	              marginBottom: (0, _typography.rhythm)(1 / 4),
	              marginTop: 0
	            }
	          },
	          post.node.frontmatter.title
	        ),
	        _react2.default.createElement(
	          'small',
	          { style: { color: 'rgba(0, 0, 0, 0.35)' } },
	          post.node.frontmatter.date,
	          ' \u2022 ',
	          readTime(post.node.wordCount.words),
	          tags.length > 0 ? ' \u2022 ' + tags.join(', ') : null
	        ),
	        _react2.default.createElement('p', {
	          style: {
	            fontSize: '90%',
	            padding: 0,
	            margin: 0
	          },
	          dangerouslySetInnerHTML: { __html: post.node.excerpt }
	        })
	      )
	    );
	  };
	
	  return _react2.default.createElement(
	    'a',
	    {
	      className: 'article-preview',
	      key: post.node.frontmatter.path,
	      href: post.node.frontmatter.path,
	      style: {
	        boxShadow: 'none',
	        color: 'hsla(0, 0%, 0%, 0.9) !important',
	        display: 'block',
	        margin: '0px -10rem 3rem'
	      }
	    },
	    _react2.default.createElement(
	      'div',
	      { style: { display: 'flex' } },
	      imgAlignLeft && img(url),
	      imgAlignLeft && preview(post),
	      !imgAlignLeft && preview(post),
	      !imgAlignLeft && img(url)
	    )
	  );
	};
	
	var Blog = function (_React$Component) {
	  _inherits(Blog, _React$Component);
	
	  function Blog() {
	    _classCallCheck(this, Blog);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Blog.prototype.render = function render() {
	    var posts = this.props.data.allMarkdownRemark.edges;
	
	    var title = 'Blog';
	    var description = 'Blog about computer science and agile software engineering.';
	
	    var meta = [{ name: 'description', content: description }, { name: 'og:image', content: _profile2.default }, { name: 'og:title', content: 'Blog' }, { name: 'og:description', description: description }, { name: 'twitter:site', content: '@matchilling' }, { name: 'twitter:creator', content: '@matchilling' }, { name: 'twitter:description', content: description }, { name: 'twitter:image', content: _profile2.default }];
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_reactHelmet2.default, { title: title, meta: meta }),
	      _react2.default.createElement(
	        'h1',
	        {
	          style: {
	            marginBottom: '3rem'
	          }
	        },
	        'What\u2019s new?'
	      ),
	      posts.map(function (post, index) {
	        if (post.node.frontmatter.path !== '/404/') {
	          var re = /\"(\/static.*?)\"/g;
	          var firstImageUrl = post.node.html.match(re);
	          var url = firstImageUrl ? 'https://www.matchilling.com' + firstImageUrl[0].replace(/['"]+/g, '') : undefined;
	
	          if (index < 3) {
	            return _react2.default.createElement(
	              'div',
	              { key: post.node.frontmatter.path },
	              _react2.default.createElement(
	                'span',
	                { className: 'hidden-xs hidden-sm visible-md visible-lg' },
	                top(post, index % 2 === 0)
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'visible-xs visible-sm hidden-md hidden-lg' },
	                standard(post)
	              )
	            );
	          }
	
	          return standard(post);
	        }
	      }),
	      _react2.default.createElement('hr', { style: { marginBottom: (0, _typography.rhythm)(1) } }),
	      _react2.default.createElement(
	        'div',
	        { style: { marginBottom: (0, _typography.rhythm)(2.5) } },
	        _react2.default.createElement(_biography2.default, null)
	      )
	    );
	  };
	
	  return Blog;
	}(_react2.default.Component);
	
	exports.default = Blog;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-blog-js-4d296d280c43303ce3cd.js